// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#footer-icon[data-v-75def770]{height:40px;width:40px}.footer-link[data-v-75def770]{color:#fff!important;line-height:30px}.footer-link[data-v-75def770]:hover{color:#fff!important;-webkit-text-decoration:underline;text-decoration:underline}#footer-container[data-v-75def770]{background-color:#212529!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
